import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiServiceBase } from './ApiServiceBase';
import { Permission } from '../common/Permission';

@Injectable({
  providedIn: 'root',
})
export class PermissionService extends ApiServiceBase {
  protected readonly path = 'permission';

  createOrUpdateMultiple(permissions: Permission[]): Observable<any> {
    return this.http
      .post(this.getUrl() + '/batchcreateorupdate', permissions);
  }

  public getByReference(refId: string, refType: string): Observable<Permission[]> {
    return this.http
      .get<Permission[]>(this.getUrl(), { params: { entityType: refType, referenceId: refId } });
  }
}
